module.exports = __webpack_public_path__ + "static/media/397.9f248590.webp";